export default __webpack_public_path__ + "static/media/networkImage.2bad7228.png";